import { getOrderLineAggregates } from '@dagensmat/core';
import { Container } from '@dagensmat/carrot/Layout';
import { Typography } from '@dagensmat/carrot/Components';
import { Order } from 'types/Order';
import OverviewTable from './OverviewTable';

type OrderOverviewGroupProps = {
  header: string;
  orders: Order[];
};
const OrderOverviewGroup = ({
  header,
  orders = []
}: OrderOverviewGroupProps) => {
  return (
    <Container my="xl">
      <Typography variant="secondaryHeading">{header}</Typography>
      <OverviewTable orderLineAggregates={getOrderLineAggregates(orders)} />
    </Container>
  );
};

export default OrderOverviewGroup;
